module.exports = __webpack_public_path__ + "img/icon2.14f52eb0.svg";